export default "__VITE_ASSET__b37862fc__"